import { render, staticRenderFns } from "./MassageTutorial.vue?vue&type=template&id=e753351e&scoped=true"
import script from "./MassageTutorial.vue?vue&type=script&lang=js"
export * from "./MassageTutorial.vue?vue&type=script&lang=js"
import style0 from "./MassageTutorial.vue?vue&type=style&index=0&id=e753351e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e753351e",
  null
  
)

export default component.exports